"use client"
 
import CommonCreate from "@/components/common/Create"
import FixedRouteForm from "./FixedRouteForm"
import { useState } from "react";

const FixedRouteCreate = () => {

    const [formProp, setFormProp] = useState({
        price: '', currency: ''
    })
    const [otherData, setOtherData] = useState<{
        origin: { text: string; lat: number; lng: number } | null,
        destination: { text: string; lat: number; lng: number } | null
    }>({
        origin: null,
        destination: null
    })
    
    const handleOtherData = (data: any, id: string) => {
        setOtherData(prev => {
            return {
                ...prev,
                [id]: data
            }
        })
    }

    return (
        <CommonCreate title="Create" resource="fixed-routes" data={{
            ...formProp,
            origin: otherData?.origin?.text,
            origin_lat: otherData?.origin?.lat,
            origin_lon: otherData?.origin?.lng,
            destination: otherData?.destination?.text,
            destination_lat: otherData?.destination?.lat,
            destination_lon: otherData?.destination?.lng,
        }}>
            <FixedRouteForm formProp={formProp} setFormProp={setFormProp} setOtherData={handleOtherData} />
        </CommonCreate>
    );
};

export default FixedRouteCreate;